import { Component, OnInit } from '@angular/core';
import { Globals } from '@constants/globals';

@Component({
  selector: 'app-layover',
  templateUrl: './layover.component.html',
  styleUrls: ['./layover.component.scss']
})
export class LayoverComponent implements OnInit {
  public showLayoverFlag: boolean = false;
  constructor(
    private globals: Globals,
  ) { }

  ngOnInit(): void {
    this.getLayoverFlagValue();
  }

  /**
   * @method: getLayoverFlagValue
   * @description: this method suscribe the global flag value to show the layover and display layover acc to it.
   */
  getLayoverFlagValue () {
    this.globals.showLayover.subscribe(value => {
      this.showLayoverFlag = value;
    });
  }



}
